import React, { useEffect, useState, useRef } from 'react';
import { Compare, FillHeart, HollowHeart } from '../Icons';
import styles from './styles.module.scss';
import cN from 'classnames';

interface I_Props {
    isCompared?: boolean;
    isFavorite?: boolean;
    setHasClicked: Function;
    typeOfAlert: 'compared' | 'favorite' | 'init'; // "compared" (比較) | "favorite" (收藏) | "init" (初始)
}

const AlertText: React.FC<I_Props> = ({
    isCompared,
    isFavorite,
    setHasClicked,
    typeOfAlert, // 觸發 Alert 由父層 isAlert 控制，Compared 和 Favorite 的改變無須觸發 re-render，用變數儲存就可以，變數 "typeOfAlert" = "compared" (比較) | "favorite" (收藏) | "init" (初始)
}) => {
    const [isOpacity, setIsOpacity] = useState<boolean>(false);
    const timeOutId_OpacityTrue = useRef<number>();
    const timeOutId_OpacityFalse = useRef<number>();
    const timeOutId_HasClickedFalse = useRef<number>();

    useEffect(() => {
        const toAlert = () => {
            // 最小有反應 14ms
            timeOutId_OpacityTrue.current = window.setTimeout(() => {
                setIsOpacity(true);
            }, 14);
            timeOutId_OpacityFalse.current = window.setTimeout(() => {
                setIsOpacity(false);
            }, 1500);

            timeOutId_HasClickedFalse.current = window.setTimeout(() => {
                setHasClicked(false);
            }, 2500);
        };
        toAlert();

        return () => {
            if (timeOutId_OpacityTrue.current) window.clearTimeout(timeOutId_OpacityTrue.current);
            if (timeOutId_OpacityFalse) window.clearTimeout(timeOutId_OpacityFalse.current);
            if (timeOutId_HasClickedFalse) window.clearTimeout(timeOutId_HasClickedFalse.current);
        };
    }, [setHasClicked, isCompared, isFavorite]);

    let compareBtn;
    if (typeOfAlert === 'compared') {
        compareBtn = isCompared ? (
            <>
                <Compare fill="#f03742" width={18} height={18} />
                <span className={cN(`${styles.text} ${styles.checked}`, 'text checked')}>
                    已加入比較
                </span>
            </>
        ) : (
            <>
                <Compare fill="#999" width={18} height={18} />
                <span className={cN(styles.text, 'text')}>取消比較</span>
            </>
        );
    }

    let favoriteBtn;
    if (typeOfAlert === 'favorite') {
        favoriteBtn = isFavorite ? (
            <>
                <FillHeart fill="#f03742" width={16} height={16} />
                <span className={cN(`${styles.text} ${styles.checked}`, 'text checked')}>
                    已加入收藏
                </span>
            </>
        ) : (
            <>
                <HollowHeart fill="#999" width={16} height={16} />
                <span className={cN(styles.text, 'text')}>取消收藏</span>
            </>
        );
    }

    return (
        <div>
            <div
                className={cN(
                    isOpacity ? `${styles.alertText} ${styles.show}` : `${styles.alertText}`,
                    isOpacity ? 'alertText show' : 'alertText'
                )}
            >
                {compareBtn}
                {favoriteBtn}
            </div>
        </div>
    );
};

export default AlertText;
